import { React, useEffect, useState, Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import LoadingPage from "../components/LoadingPage";
import axiosRio from "../hooks/axiosRio";
import requests from "../hooks/requests";
import { db } from "../firebase";
import {
	getDoc,
	setDoc,
	doc,
	getDocs,
	collection,
	where,
	query,
} from "firebase/firestore";
import { useAppSelector, useAppDispatch } from "../app/hooks";
import { setGuild, setMembers } from "../features/guild/guild-slice";
import moment from "moment";

const Home = () => {
	// Set the state for the guild and the members of the guild
	const dispatch = useAppDispatch();
	const guild = useAppSelector((state) => state.guild);
	// States for the loading page or the error page
	const [error, setError] = useState(false);
	const [loading, setLoading] = useState(true);

	// Lazy load the components
	const GuildDashboard = lazy(() => import("../views/GuildDashboard"));
	const PlayersView = lazy(() => import("../views/PlayersView"));
	const PlayerDetail = lazy(() => import("../views/PlayerDetail"));
	const RecruitmentView = lazy(() => import("../views/RecruitmentView"));
	const Comparator = lazy(() => import("../views/Comparator"));

	useEffect(() => {
		// Get the guild data from the database
		const getGuildData = async (guildName) => {
			try {
				const guildQuery = doc(db, "guild", guildName);
				const guild = await getDoc(guildQuery);
				return guild.data();
			} catch (error) {
				console.log(error);
			}
		};

		const getGuildMembers = async (guildName) => {
			try {
				const guildQuery = query(
					collection(db, "players"),
					where("guild.name", "==", guildName)
				);
				const guildMembers = await getDocs(guildQuery);
				const members = guildMembers.docs.map((doc) => doc.data());
				return members;
			} catch (error) {
				console.log(error);
			}
		};

		getGuildMembers("Amentibus Cultui").then((data) => {
			dispatch(setMembers({ members: data }));
		});

		const updateGuildData = async (guildName, data) => {
			try {
				const guildRef = doc(
					db,
					"guild",
					guildName.replace(/[^a-zA-Z]+/g, "-").toLowerCase()
				);
				await setDoc(guildRef, data);
			} catch (error) {
				console.log(error);
			}
		};

		const fetchData = async () => {
			try {
				const response = await axiosRio.get(requests.fetchGuild.url, {
					params: requests.fetchGuild.params,
				});
				const guild = response.data;

				if (guild) {
					updateGuildData(guild.name, guild);
					dispatch(
						setGuild({
							name: guild.name,
							realm: guild.realm,
							region: guild.region,
							data: guild,
						})
					);
					setLoading(false);
				}
				setLoading(false);
			} catch (error) {
				setError(true);
			}
		};

		getGuildData("amentibus-cultui").then((guild) => {
			if (guild) {
				// compare the last updated date with the current date and update the data if it's older than 24 hours
				const lastUpdated = moment(guild.lastUpdate);
				const now = moment(new Date());
				const diffBetween = now.diff(lastUpdated, "hours");
				if (diffBetween > 2) {
					fetchData().then(() => {
						setLoading(false);
					});
				} else {
					dispatch(
						setGuild({
							name: guild.name,
							realm: guild.realm,
							region: guild.region,
							data: guild,
						})
					);
					setLoading(false);
				}
			} else {
				fetchData().then(() => {
					setLoading(false);
				});
			}
		});
	}, [dispatch]);

	if (loading) return <LoadingPage />;
	if (error) return <div>ERROR: {error.message}</div>;

	return (
		guild && (
			<Suspense fallback={<LoadingPage />}>
				<div className="main-view bg-neutral-900/80 py-10">
					<Routes>
						<Route path="/dashboard" element={<GuildDashboard />} />
						<Route path="/" element={<GuildDashboard />} />
						<Route path="/players" element={<PlayersView />} />
						<Route
							path="/players/:region/:realm/:name"
							element={<PlayerDetail />}
						/>
						<Route path="/recruitment" element={<RecruitmentView />} />
						<Route path="/comparator" element={<Comparator />} />
					</Routes>
				</div>
			</Suspense>
		)
	);
};
export default Home;
